<template>
  <div>
    <multiselect
      v-bind="filteredProps"
      :value="internalValue"
      @input="updateSelected"
      :searchable="searchable"
      :internal-search="false"
      @search-changed="loadRemoteEntities"
      :loading="isLoading"
      :options="internalOptions"
      :label="label"
      :max="max"
    >
      <span slot="noResult">{{ noResult }}</span>
    </multiselect>
  </div>
</template>
<script>
import multiselectMixin from 'vue-multiselect';
import selectMixin from '@/mixins/selectMixin';

export default {
  name: 'enyo-select',
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    label: String,
    trackBy: [String, Number],
    vModelValue: [String, Number, Array, Object],
    noResult: String,
    url: String,
    multiple: [String, Boolean],
    disabled: [String, Boolean],
    readonly: [String, Boolean],
    searchable: {
      type: [String, Boolean, Number],
      default: false,
    },
    max: [Number]
  },
  model: {
    prop: 'vModelValue',
    event: 'input',
  },
  mixins: [selectMixin],
  data() {
    return {
      isLoading: false,
      apiOptions: false,
    };
  },

  watch: {
     'vModelValue': function (newValue, oldValue) {
       this.setIncomingValue(newValue);
     }
  },

  computed: {
    internalOptions() {
      return this.apiOptions || this.options;
    },

    filteredProps() {
      const props = { ...this.$props };
      delete props.vModelValue;
      delete props.input;
      delete props.value;
      return props;
    },
  },
  methods: {

    // Sets the value from the the the v-model attribute
    setIncomingValue(value) {
      console.log('[EnyoSelect] setIncomingValue :', value)
      //  ne pas traiter une valeur undefined envoyée depuis le mounted du select mixin 
      if (value === undefined) {
        return;
      }
      this.internalValue = value; 
      if (Array.isArray(value)) {
        console.log('[EnyoSelect] isArray')
        console.log('[EnyoSelect] this.internalOptions', JSON.stringify(this.internalOptions))
        if(this.internalOptions && this.internalOptions.length) {
          this.internalValue = value.map((val) => {
            if (typeof val === 'object') {
              return val;
            }
            return this.internalOptions.find(option =>  {
              const searchKey = typeof option === 'string' ? option : option[this.trackByComputed];
              if (typeof option === 'object') {
                return option[this.trackByComputed] === val;
              }
              option == value;
             });
            });
      }
      return;
      }
      this.internalValue = this.internalOptions
        && this.internalOptions.find((option) => {
          const searchKey = typeof option === 'string' ? option : option[this.trackByComputed];
          return `${searchKey}` === `${value}`;
        });
      // this.myModel = this.internalValue;
    },

  },

  created() {
    // Check if the component is loaded globally
    if (!this.$root.$options.components.multiselect) {
      console.error(
        "'vue-multiselect' is missing. Please download from https://github.com/monterail/vue-multiselect and register the component globally!"
      );
    }
  },

  mounted() {
    this.setIncomingValue(this.vModelValue);
    this.loadRemoteEntities().then((ok) => {
      if (ok) {
        this.setIncomingValue(this.vModelValue);
      }
    });
  },
};
</script>
<style lang="scss">
@import '../../../src/assets/sass/theme/_variables.scss';

.multiselect__tag {
  background: $primary !important;
  color: #fff !important;
}


.multiselect__select:before {
    position: absolute !important;
    right: 9px !important;
    top: 45% !important;
}
</style>
